export const OKTA_MY_ACCOUNT_SCOPES = [
  'openid',
  'profile',
  'email',
  'okta.myAccount.email.read',
  'okta.myAccount.email.manage',
]

export const OKTA_MY_ACCOUNT_TOKEN_HEADER = 'x-okta-myaccount-token'
